import APP from "./utils/app"
// NOTE: In development server, do not send the crash report. (https://developers.google.com/analytics/devguides/collection/gtagjs/user-opt-out)
// If a debug mode is needed, just comment the below.
if (location.hostname.includes('local')) window['ga-disable-G-XGCRGFP90J'] = true
// NOTE: The following code should be near the top of the <head> tag and before any other scripts or CSS tags.
window.dataLayer = window.dataLayer || []
function gtag() { dataLayer.push(arguments) }
gtag('js', new Date())
// NOTE: debug mode - https://support.google.com/analytics/answer/7201382
if (location.hostname.includes('local')) gtag('config', 'G-XGCRGFP90J', { 'debug_mode': true })
else gtag('config', 'G-XGCRGFP90J') // To disable debug mode, exclude the 'debug_mode' parameter; setting the parameter to false DOES NOT disable debug mode.
// Note: To access error logging via window.onerror, crossorigin="anonymous" must be used in <script src> in html because you don't want to see only 'Script error.' in description. (ref: https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/crossorigin)
// general java script crash detector
window.onerror = function (message, source, lineno, colno, error) {
    send2ga(message + " (" + source + ":" + lineno + ")");
    reportClientError(message, error, source, lineno, colno);
};

// java script crash in promise detector
window.onunhandledrejection = function (data) {
    send2ga( data.reason.stack ? data.reason.stack : data.reason );
    const error = data.reason;
    const message = (error && typeof error === "object" && "message" in error && error.message) ||
            (typeof error === "string" && error) || "Unhandled rejection";
    reportClientError(message, error);
};

// After detecting js crash, error message will be sent to google analytics. (https://support.google.com/analytics/answer/11150547)
const send2ga = (text) => gtag('event', 'exception', { 'description': String(text) })

// GCP JS Error Reporting
function reportClientError(message, error, source, lineno, colno) {
     if (location.hostname.includes('local')) return
    const norm = normalizeError(error)

    const cleanedStack = (norm.stack  || "No stack")
        .replace(/^Error:.*\n?/, "")
        .replace(/^Trace capture\n?/, "")
        .trim();

    const safeMsg = safeString(norm.message || message);
    const baseMessage = safeMsg.startsWith("Error:") ? safeMsg : `Error: ${safeMsg}`;

    let contextHeader = `href=${safeString(location.href)}\n`;
    if (source) contextHeader += `src=${safeString(source)} - line:${Number(lineno || 0)}:col:${Number(colno || 0)}\n`;
    contextHeader += `thrownType=${norm.type}\n`;
    if (norm.message && norm.message !== message) contextHeader += `thrownMessage=${message}\n`;
    

    const fullMessage =
        `${baseMessage}\n` +
        `${cleanedStack}\n\n` +
        `${contextHeader}`;

    const fd = new FormData()
    fd.append("message", fullMessage)
    fd.append("version", APP.version())
    fd.append("buildDate", APP.buildDate())

    const BASE_API_URL = import.meta.env.VITE_API_BASE ?? "";
    fetch(`${BASE_API_URL}/v1/client-error-report/report`, {
        method: "POST",
        body: fd
    }).catch(err => {
        console.warn("Failed to send error report:", err);
    });
}

function normalizeError(error) {
  if (error && typeof error === "object") {
    const message = safeString(error.message) || safeString(error.error) || safeString(error.reason) || "";
    const stack = safeString(error.stack || error.traceStack || "");
    const type = error.constructor?.name ? error.constructor.name : "object";
    return { type, message, stack };
  }

  const type = typeof error;
  const message = safeString(error);
  return { type, message, stack: "" };
}

function safeString(v) {
  return v == null ? "" : String(v);
}

